import { withCompInfo } from '@wix/editor-elements-integrations'
import { ItunesButtonCSSVars, ItunesButtonDefinition } from './ItunesButton'

export const css = withCompInfo<ItunesButtonCSSVars, ItunesButtonDefinition>()(
	['compLayout', 'isOneDocMigrated'],
	({ compLayout, isOneDocMigrated }) => {
		return isOneDocMigrated ? {} : { height: `${(compLayout.width! * 40) / 110}px` }
	}
)
